import lo from "lodash";

export function camelCased(data: any) {
    if (Array.isArray(data)) return data.map(camelCased);
    if (data === null) return data;
    if (typeof data !== "object") return data;

    const camelizedData = {};
    Object.keys(data).forEach((key) => {
        const camelKey = lo.camelCase(key);
        camelizedData[camelKey] = camelCased(data[key]);
    });
    return camelizedData;
}
